module.exports = __webpack_public_path__ + "static/media/userpic.960f0178.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userpic.svg
// module id = 918
// module chunks = 7